/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Banner
 */
export interface Banner {
    /**
     * 배너 uuid
     * @type {string}
     * @memberof Banner
     */
    'bannerUuid': string;
    /**
     * 제목
     * @type {string}
     * @memberof Banner
     */
    'title': string;
    /**
     * 부제목
     * @type {string}
     * @memberof Banner
     */
    'subtitle': string;
    /**
     * 링크
     * @type {string}
     * @memberof Banner
     */
    'link'?: string;
    /**
     * 링크 타입
     * @type {string}
     * @memberof Banner
     */
    'linkType'?: BannerLinkTypeEnum;
    /**
     * 이미지
     * @type {string}
     * @memberof Banner
     */
    'image': string;
    /**
     * 노출 여부
     * @type {boolean}
     * @memberof Banner
     */
    'isExposed': boolean;
    /**
     * 생성 일시
     * @type {string}
     * @memberof Banner
     */
    'createdAt': string;
    /**
     * 이전 배너 uuid
     * @type {string}
     * @memberof Banner
     */
    'prevBannerUuid': string;
}

export const BannerLinkTypeEnum = {
    Self: 'self',
    Blank: 'blank'
} as const;

export type BannerLinkTypeEnum = typeof BannerLinkTypeEnum[keyof typeof BannerLinkTypeEnum];


